import { api, setToken } from './httpClient';

export const authApi = {
  register: (body) => api('/auth/register', { method: 'POST', body: JSON.stringify(body) }),
  login: (body) => api('/auth/login', { method: 'POST', body: JSON.stringify(body) }),
  resetPassword: (body) => api('/auth/reset-password', { method: 'POST', body: JSON.stringify(body) }),
  me: () => api('/auth/me'),
  validateReferral: (code) => api(`/auth/referral/${encodeURIComponent(code)}`),
  logout: () => {
    setToken(null);
    localStorage.removeItem('eleven_games_user');
  },
  saveSession: ({ token, user }) => {
    setToken(token);
    localStorage.setItem('eleven_games_user', JSON.stringify(user));
  },
  getStoredUser: () => {
    try {
      return JSON.parse(localStorage.getItem('eleven_games_user') || 'null');
    } catch {
      return null;
    }
  },
};
